import React from "react";
import Card from "./Card";

const DashboardCards: React.FC = () => {
  const cards = [
    {
      title: "Engineer wise Uptime Tracker Dashboard",
      description: "Analyze Device performance.",
      icon: "/images/UptimeTracker.png",
      link: "",
      isExternal: true,
    },
    {
      title: "Operations Dashboard",
      description: "Track operational metrics.",
      icon: "/images/Operations.png",
      link: "",
      isExternal: true,
    },
    {
      title: "Customer Success Dashboard",
      description: "Track complaints.",
      icon: "/images/Support.png",
      link: "",
      isExternal: true,
    },
    {
      title: "MIS - Fortnightly Dashboard",
      description: "MIS 15 Days Report",
      icon: "/images/management-information-system.png",
      link: "",
      isExternal: true,
    },
    {
      title: "Kazam Board",
      description: "Overview of kazam",
      icon: "/images/kazamboard.png",
      link: "",
      isExternal: true,
    },
  ];

  return (
    <div className="px-4 py-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <Card
          key={index}
          title={card.title}
          description={card.description}
          icon={card.icon}
          link={card.link}
          isExternal={card.isExternal}
        />
      ))}
    </div>
  );
};

export default DashboardCards;
